<template>
  <div v-if="type === 'mdzn'" class="w-full mt-4" v-html="data.product_html"></div>
  <div v-else>
    <div class="w-full mt-4 flex items-end">
      <OButton
        size="sm"
        class="flex items-center sm:ml-auto font-semibold hover:bg-o-blue text-md sm:text-lg"
        :style="{ backgroundColor: `#${data.product_bcolor || 'f89306'}` }"
        :href="data.product_url"
        target="_blank"
        rel="nofollow noopener sponsored"
      >
        {{ data.product_title ? data.product_title : 'Ürünü İncele' }}
        <OIcon icon="external-white" class="ml-1 sm:ml-2" svg-class="h-4 w-4 sm:h-5 sm:w-5" />
      </OButton>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OIcon, OButton } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon, OButton },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const type = props.data && props.data?.product_source === 'mdzn' ? 'mdzn' : 'default';
    return { type };
  },
});
</script>
